<div class="wrapper shadowed">
  <div class="shadowed row justify-content-left installation-head" *ngIf="!installations">
    <strong>Chargement des installations...</strong>
  </div>

  <div class="shadowed row justify-content-left installation-head" *ngIf="installations">
    <form [formGroup]="formInstall">
      <div class="attributs">
        <p>Installation :
          <mat-form-field>
            <mat-select [(value)]="selectedInstallation" formControlName="installation" style="width:50vw"
              (selectionChange)="getInstallation($event)">
              <input (keyup)="onKey($event)" placeholder="Chercher..." class="form-control">
              <mat-option *ngFor="let installation of filteredInstallations" [value]="installation">
                {{installation.nom_installation}} ({{installation.numero_serie}})
              </mat-option>
            </mat-select>
          </mat-form-field>
        </p>
        <p *ngIf="selectedInstallation">La société facturée est
          {{selectedInstallation.societe_proprietaire_raison_sociale}}</p>
      </div>
    </form>
  </div>
  <mat-tab-group mat-align-tabs="center">

    <mat-tab label="Vérifications">
      <app-call-verifs (composantEvent)='getPannesForComposant($event)' (resetMachine)='resetSelectedMachine($event)'
        [snMachine]='snMachine'></app-call-verifs>
    </mat-tab>

    <mat-tab label="Pannes sur ce composant">
      <app-call-dap-infos [pannes]="codesPannes"></app-call-dap-infos>
    </mat-tab>

    <mat-tab label="Pannes sur cette machine">
      <app-installation-interventions *ngIf="installationDetails" [idMachine]="installationDetails.machine.id_machine"
        [loading]="loading"></app-installation-interventions>
      <div *ngIf="!installationDetails">Choisissez une installation</div>
    </mat-tab>

    <mat-tab label="Rapport">
      <app-call-rapport *ngIf="installationDetails" [installation]="installationDetails" [suiviId]="suiviId"
        [detailAppel]="detailAppel">
      </app-call-rapport>
      <app-call-rapport *ngIf="!installationDetails" [suiviId]="suiviId" [detailAppel]="detailAppel">
      </app-call-rapport>
    </mat-tab>

  </mat-tab-group>
</div>